/*****************************************************************************************
 * 설명 : AG Grid — remountKey 변경 시 그리드 전체 재생성 (컬럼 초기화 즉시 반영)
*****************************************************************************************/
import { AgGridReact } from 'ag-grid-react';

const AgGridReactEx = ({ remountKey = 0, ...props }) => (
  <AgGridReact
    key={`ag-grid-remount-${remountKey}`}
    {...props}
  />
);

export default AgGridReactEx;
